<template>
  <section class="ads-card">
    <header class="ads-card-head">
      <span class="ads-card-bar" aria-hidden="true"></span>
      <h3>{{ title }}</h3>
      <span class="ads-card-tag">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 11 18-5v12L3 14v-3z"/><path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/></svg>
        Google Ads
      </span>
    </header>

    <MetricSeriesBlock
      :metrics="ADS_METRICS"
      :data="data"
      :loading="loading"
      :default-selected="['clicks', 'cost']"
    />
  </section>
</template>

<script setup>
import MetricSeriesBlock from './MetricSeriesBlock.vue'

defineProps({
  title: { type: String, default: '' },
  data: { type: Object, default: null },
  loading: { type: Boolean, default: false },
})

const ADS_METRICS = [
  { key: 'impressions',         label: 'Impresiones',  color: '#ffc434', axis: 'count', fmt: 'int' },
  { key: 'clicks',              label: 'Clics',        color: '#64748b', axis: 'count', fmt: 'int' },
  { key: 'conversions',         label: 'Conversiones', color: '#ffc434', axis: 'count', fmt: 'num1' },
  { key: 'cost',                label: 'Costo',        color: '#64748b', axis: 'money', fmt: 'money' },
  { key: 'cpc',                 label: 'CPC',          color: '#64748b', axis: 'money', fmt: 'money2' },
  { key: 'cost_per_conversion', label: 'Costo/conv.',  color: '#64748b', axis: 'money', fmt: 'money' },
]
</script>

<style scoped>
.ads-card {
  background: var(--card-bg, #fff);
  border: 1px solid var(--card-border, #e5e7eb);
  border-radius: var(--card-radius, 16px);
  padding: 16px;
  box-shadow: var(--card-shadow, 0 1px 2px rgba(0, 0, 0, .04));
  -webkit-backdrop-filter: var(--card-blur, none);
  backdrop-filter: var(--card-blur, none);
  position: relative;
  overflow: hidden;
}
.ads-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 2px;
  background: var(--card-topline, linear-gradient(90deg, transparent, rgba(56, 189, 248, .55), transparent));
  pointer-events: none;
}

.ads-card-head { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
.ads-card-bar { width: 4px; height: 18px; border-radius: 999px; background: var(--accent-grad, linear-gradient(180deg, #38bdf8, #818cf8)); flex: 0 0 auto; }
.ads-card-head h3 { margin: 0; font-size: 14px; font-weight: 700; color: var(--card-title, #0f172a); flex: 1; }
.ads-card-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .4px;
  text-transform: uppercase;
  color: var(--text-muted, #64748b);
  padding: 4px 10px;
  border-radius: 999px;
  background: var(--kpi-bg, #f1f5f9);
  border: 1px solid var(--border, #e5e7eb);
  white-space: nowrap;
}
.ads-card-tag svg { width: 14px; height: 14px; color: var(--accent, #0ea5e9); }
</style>
